var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoAppointmentEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#6D7D8B",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1156 61.375H31.375C30.3804 61.375 29.4266 60.9799 28.7233 60.2766C28.0201 59.5734 27.625 58.6196 27.625 57.625V35.125C27.625 34.1304 28.0201 33.1766 28.7233 32.4733C29.4266 31.7701 30.3804 31.375 31.375 31.375H53.875C54.8696 31.375 55.8234 31.7701 56.5266 32.4733C57.2299 33.1766 57.625 34.1304 57.625 35.125V42.625",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 63.25C59.8921 63.25 63.25 59.8921 63.25 55.75C63.25 51.6079 59.8921 48.25 55.75 48.25C51.6079 48.25 48.25 51.6079 48.25 55.75C48.25 59.8921 51.6079 63.25 55.75 63.25Z",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.125 27.625V35.125",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.125 27.625V35.125",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 42.625H57.625",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 52.9299V55.7499L57.625 57.6249",
    stroke: "#6D7D8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoAppointmentEmpty);
export default __webpack_public_path__ + "static/media/roAppointmentEmpty.15016604.svg";
export { ForwardRef as ReactComponent };